import { DateCellRendererComponent } from "../../../../shared/common-components/ag-grid/date-cell-renderer/date-cell-renderer.component";
import { StorageName } from "../../../../shared/enum/common-enum";
import { API_URL_GET_ALLINSTALLMENTFUNDREPORTLEDGERLIST } from "../../../../shared/url-helper/url-helper";
import { TextRendererComponent } from "../../../../shared/common-components/ag-grid/text-renderer/text-renderer.component";
import { AgColDefsI, AgGridI } from "../../../../shared/common-components/ag-grid/ag-grid.model";
import { NumericCellRendererComponent } from "../../../../shared/common-components/ag-grid/numeric-cell-renderer/numeric-cell-renderer.component";

export class InstallmentReport {
}

const Customer: AgColDefsI = {
  headerName: "Party",
  field: "ledgerName",
  resizable: true,
  sortable: false,
  minWidth: 200,
  editable: false,
  headerClass: "px-1 custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: TextRendererComponent,
  headerComponentParams: {
    filterValueColumnName: "ledgerName",
    filterIdColumnName: "ledgerName",
    isInputFilter: true,
  },
  cellRendererParams: { isCursor: false },
  cellClass: 'px-0 cursorPointer custom-column-group-cell text-primary',
};

const NoOfItems: AgColDefsI = {
  headerName: "No. Of Schemes",
  field: "noOfSchemesCount",
  resizable: true,
  sortable: false,
  minWidth: 80,
  flex: 1,
  editable: false,
  headerClass: "px-1 custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isCursor: true, },
  headerComponentParams: {
    filterValueColumnName: "noOfSchemesCount",
    filterIdColumnName: "noOfSchemesCount",
    isInputFilter: true,
    isAllowNumber: true
  },
  cellClass: 'px-2 cursorPointer custom-column-group-cell text-center',
};
export const ColDefsInstallmentReportList: AgColDefsI[] = [
  Customer,
  NoOfItems,
];

export const AgGridDataModelInstallmentReportList: AgGridI = {
  colDefs: ColDefsInstallmentReportList,
  rowSelection: "multiple",
  storageName: StorageName.TRANSACTION_INSTALLMENT_REPORT_LEDGERLIST_GRID,
  filterStorageName: StorageName.FILTER_TRANSACTION_INSTALLMENT_REPORT_LEDGERLIST_GRID,
  sortStorageName: StorageName.SORT_TRANSACTION_INSTALLMENT_REPORT_LEDGERLIST_GRID,
  paginationStorageName: StorageName.PAGINATION_TRANSACTION_INSTALLMENT_REPORT_LEDGERLIST_GRID,
  initialRows: StorageName.TRANSACTION_INSTALLMENT_REPORT_LEDGERLIST_GRID_INITIAL_ROWS,
  rows: [],
  headerHeight: 70,
  isFilter: true,
  isServerSidepagination: false,
  apiUrl: API_URL_GET_ALLINSTALLMENTFUNDREPORTLEDGERLIST,
  showPagination: false
};

const CustomerColumn: AgColDefsI = {
  headerName: "Customer",
  field: "customerName",
  resizable: true,
  sortable: true,
  minWidth: 100,
  flex: 1,
  editable: false,
  headerClass: "px-1 custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: TextRendererComponent,
  cellClass: 'custom-column-group-cell',
};
const SchemeColumn: AgColDefsI = {
  headerName: "Scheme Name",
  field: "schemeName",
  resizable: true,
  sortable: true,
  minWidth: 100,
  flex: 1,
  editable: false,
  headerClass: "px-1 custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: TextRendererComponent,
  cellClass: 'custom-column-group-cell',
};
const SalepersonColumn: AgColDefsI = {
  headerName: "Sale Person",
  field: "salesPersonName",
  resizable: true,
  sortable: true,
  minWidth: 100,
  flex: 1,
  editable: false,
  headerClass: "px-1 custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: TextRendererComponent,
  cellClass: 'custom-column-group-cell',
};

const InstTypeColumn: AgColDefsI = {
  headerName: "Inst.Type",
  field: "installmentTypeName",
  resizable: true,
  sortable: true,
  minWidth: 100,
  flex: 1,
  editable: false,
  headerClass: "px-1 custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: TextRendererComponent,
  cellClass: 'custom-column-group-cell',
};

const RedemptionColumn: AgColDefsI = {
  headerName: "Redemption On",
  field: "redemptionOnName",
  resizable: true,
  sortable: true,
  minWidth: 100,
  flex: 1,
  editable: false,
  headerClass: "px-1 custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: TextRendererComponent,
  cellClass: 'custom-column-group-cell',
};

const JoiningColumn: AgColDefsI = {
  headerName: "Joining Dt.",
  field: "joiningDate",
  resizable: true,
  sortable: true,
  minWidth: 80,
  editable: false,
  headerClass: "px-1 ag_header_end custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: DateCellRendererComponent,
  cellClass: 'px-2 cursorPointer custom-column-group-cell text-end',
};
const MaturityDate: AgColDefsI = {
  headerName: "Maturity Dt.",
  field: "maturityDate",
  resizable: true,
  sortable: true,
  minWidth: 80,
  editable: false,
  headerClass: "px-1 ag_header_end custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: DateCellRendererComponent,
  cellClass: 'px-2 cursorPointer custom-column-group-cell text-end',
};

const AmountColumn: AgColDefsI = {
  headerName: "Inst. Amt.",
  field: "installmentAmount",
  resizable: true,
  sortable: true,
  minWidth: 80,
  editable: false,
  headerClass: "px-1 ag_header_end custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isReadOnly: true, isCursor: false, isAmt: true },
  cellClass: 'px-2 cursorPointer custom-column-group-cell text-end',
};

const TotalAmountColumn: AgColDefsI = {
  headerName: "Total Amt.",
  field: "totalAmount",
  resizable: true,
  sortable: true,
  minWidth: 80,
  editable: false,
  headerClass: "px-1 ag_header_end custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isReadOnly: true, isCursor: false, isAmt: true },
  cellClass: 'px-2 cursorPointer custom-column-group-cell text-end',
};

const PaidAmountColumn: AgColDefsI = {
  headerName: "Paid Amt.",
  field: "paidAmount",
  resizable: true,
  sortable: true,
  minWidth: 80,
  editable: false,
  headerClass: "px-1 ag_header_end custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isReadOnly: true, isCursor: false, isAmt: true },
  cellClass: 'px-2 cursorPointer custom-column-group-cell text-end',
};
const BalAmountColumn: AgColDefsI = {
  headerName: "Bal. Amt.",
  field: "balanceAmount",
  resizable: true,
  sortable: true,
  minWidth: 80,
  editable: false,
  headerClass: "px-1 ag_header_end custom-column-group-cell",
  headerCheckboxSelection: false,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isReadOnly: true, isCursor: false, isAmt: true },
  cellClass: 'px-2 cursorPointer custom-column-group-cell text-end',
};

export const ColDefsInstallmentReportDetailsList: AgColDefsI[] = [
  CustomerColumn,
  SchemeColumn,
  SalepersonColumn,
  InstTypeColumn,
  RedemptionColumn,
  JoiningColumn,
  MaturityDate,
  AmountColumn,
  TotalAmountColumn,
  PaidAmountColumn,
  BalAmountColumn,
];

export const AgGridDataModelInstallmentReportDetailsList: AgGridI = {
  colDefs: ColDefsInstallmentReportDetailsList,
  rowSelection: "multiple",
  storageName: StorageName.TRANSACTION_INSTALLMENTREPORT_DETAILS_GRID,
  filterStorageName: StorageName.FILTER_TRANSACTION_INSTALLMENTREPORT_DETAILS_GRID,
  rows: [],
  rowHeight: 28,
};

export class FilterList {
  name: string;
  textFilter: string;
  filterData: FilterDaum[];
}
export class FilterDaum {
  id: number;
  name: string;
}